import { createSlice } from "@reduxjs/toolkit";

const productDetailsSlice = createSlice({
  name: "productDetails",
  initialState: { post: {}, loading: false, error: null },
  reducers: {
    getProductDetailsRequest: (state) => {
      state.loading = true;
    },
    getProductDetailsSuccess: (state, action) => {
      state.loading = false;
      state.post = action.payload;
    },
    getProductDetailsFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearErrors: (state) => {
      state.error = null;
    },
  },
});

export const {
  getProductDetailsRequest,
  getProductDetailsSuccess,
  getProductDetailsFail,
  clearErrors,
} = productDetailsSlice.actions;

export default productDetailsSlice.reducer;
